export const htmlToPlainText = (
  text: string,
  config?: {
    preserveBrLineBreak?: boolean;
    preserveTextLineBreak?: boolean;
  },
) => {
  let processedText = text;

  if (config?.preserveTextLineBreak) {
    // Add line breaks after paragraphs and list items
    processedText = processedText
      .replace(/<\/p>/gi, '</p>\n')
      .replace(/<li>/gi, '<li>-&nbsp;')
      .replace(/<ul>/gi, '<ul>\n')
      .replace(/<\/li>/gi, '</li>\n')
      .replace(/<br>/gi, '\n');
  }

  const div = document.createElement('div');
  div.innerHTML = processedText;
  const plainText = div.innerText;

  if (config?.preserveBrLineBreak) {
    return plainText.replace(/\n/g, '<br>');
  }

  return plainText;
};
